export default {
  path: '/tags',
  name: 'tags',
  component: () => import('../components/tag/Layout'),
  redirect: { name: 'TagList' },
  meta: {
    breadcrumb: 'tag.tags',
  },
  children: [
    {
      name: 'TagList',
      path: '',
      component: () => import('../views/tag/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'TagCreate',
      path: 'new',
      component: () => import('../views/tag/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'TagUpdate',
      path: ':id/edit',
      component: () => import('../views/tag/Update'),
      meta: {
        breadcrumb: 'tag.tag',
      },
    },
    {
      name: 'TagShow',
      path: ':id',
      component: () => import('../views/tag/Show'),
      meta: {
        breadcrumb: 'tag.tag',
      },
    }
  ]
};
